import * as React from 'react';
import { Chip, ChipGroup } from '@patternfly/react-core';
import UserInterface from '@app/Interface/UserInterface';
import UserRoleTypesInterface from '@app/Interface/UserRoleTypesInterface';

interface UserAccessChipsProps {
    user: UserInterface;
    producerId: number;
    roleTypes: UserRoleTypesInterface[];
}

const UserRoleTypeChips: React.FC<UserAccessChipsProps> = ({ user, producerId, roleTypes }) => {

    const [permissionChips, setPermissionChips] = React.useState<string[]>([]);

    // setup chips data
    React.useEffect(() => {

        const chips: string[] = [];

        if (typeof user.fpuRoles !== "boolean") {

            const roles = user.fpuRoles.find(role => Number(role.fpu) === Number(producerId));
    
            if (roles) {

                roles.fpu_roles.forEach(roleId => {

                    const roleType = roleTypes.find(roleType => roleType.id === roleId);

                    const roleName = roleType?.title ?? "Not found";

                    chips.push(roleName);

                });

            }
    
        }

        setPermissionChips(chips);
    
    }, [producerId, user.fpuRoles, roleTypes]);

    return (
        <ChipGroup>
            {permissionChips.map((permission, chipIndex) => (
                <Chip key={chipIndex} isReadOnly>{permission}</Chip>
            ))}
        </ChipGroup>
    );

}

export default UserRoleTypeChips;
